import React from 'react';
import PropTypes from 'prop-types';

export const Image = ({url, title, width, height}) => {
    return (
              <div>
                <img src={url} alt={title} width={width} height={height} />
              </div>
    );

};

Image.propTypes = {
    url: PropTypes.string.isRequired,
    title : PropTypes.string.isRequired,
    width : PropTypes.string,
    height : PropTypes.string
};